// src/i18n.js
import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

let messages = {
  en: {
    "language": "Language",
    "LANG": "LANG",
    "search": "Search",
    "filters": "Filters",
    "dashboard": "Dashboard",
    "p-m2": "p/m2",
    "size": "Size",
    "floors": "floors",
    "zone-1": "Zone 1",
    "zone-2": "Zone 2",
    "full-report": "Full Report",
    "results-are-loading": "Results are loading...",
    "zoom-in-for-results": "Zoom in for results",
    "search-for-parcels": "Search For Parcels",
    "canton": "Canton",
    "municipality": "Municipality",
    "street": "Street",
    "parcel-no": "Parcel No",
    "parcel-id": "Parcel ID",
    "parcel-size-from": "Parcel Size From",
    "parcel-size-to": "Parcel Size To",
    "thermal": "Thermal",
    "freeway-from": "Freeway From",
    "freeway-to": "Freeway To",
    "putra-from": "Putra From",
    "putra-to": "Putra To",
    "alpha-primary": "Alpha Primary",
    "alpha-secondary": "Alpha Secondary",
    "loading": "Loading...",
    "basic-data-building": "BASIC DATA-BUILDING",
    "basic-data-parcel": "BASIC DATA - PARCEL",
    "name": "Name",
    "value": "Value",
    "coordinates-center": "Coordinates Center",
    "country": "Country",
    "canton-state": "Canton / State",
    "postal-code": "Postal Code",
    "number": "Number",
    "approx-price-m": "Approx. Price / m²",
    "approx-total-price": "Approx. Total Price",
    "responsible-surveyor": "Responsible Surveyor",
    "detached": "Detached",
    "built-up": "Built-up",
    "built-up-divisible": "Built-up, divisible",
    "fixed-point-network-hfp-lfp-1-3": "FIXED POINT NETWORK (HFP+LFP 1-3)",
    "fixed-point-id": "Fixed Point ID",
    "fixed-point-number": "Fixed Point Number",
    "fixed-point-name": "Fixed Point Name",
    "fixed-point-type": "Fixed Point Type",
    "coordinates": "Coordinates",
    "altitude": "Altitude",
    "distance-to-parcel": "Distance to Parcel",
    "object-id": "Object ID",
    "footprint-area": "Footprint Area",
    "building-volume": "Building Volume",
    "centered-coordinates": "Centered Coordinates",
    "object-type": "Object Type",
    "number-of-floors": "Number of Floors",
    "number-of-units": "Number of Units",
    "year-of-construction": "Year of Construction",
    "construction-period": "Construction Period",
    "listed": "Listed",
    "basic-zoning-plan": "BASIC ZONING PLAN",
    "alpha-pri": "Alpha PRI",
    "alpha-sec": "Alpha SEC",
    "alpha-ter": "Alpha TER",
    "special-zoning-plan": "SPECIAL ZONING PLAN",
    "zpp-bravo-pri": "ZPP Bravo PRI",
    "ueo-bravo-sec": "UeO: Bravo SEC",
    "usp-bravo-ter": "USP: Bravo TER",
    "overlay-zoning-plan": "OVERLAY ZONING PLAN",
    "base-building-lines": "Base Building Lines",
    "building-lines-cantonal-roads": "Building Lines Cantonal Roads",
    "building-lines-national-roads": "Building Lines National Roads",
    "building-lines-forest-distance": "Building Lines Forest Distance",
    "noise-sensitivity-level": "Noise Sensitivity Level",
    "water-space-line": "Water Space Line",
    "water-space": "Water Space",
    "soil-use-and-risks": "SOIL (USE AND RISKS)",
    "building-ground-assumption": "Building Ground (Assumption)",
    "use-of-geothermal-probes": "Use of Geothermal Probes",
    "use-of-groundwater": "Use of Groundwater",
    "radon-content": "Radon Content",
    "site-contamination-kbs": "Site Contamination (KBS)",
    "infiltration-zones": "Infiltration Zones",
    "natural-hazards": "NATURAL HAZARDS",
    "fall-hazard": "Fall Hazard",
    "avalanche-hazard": "Avalanche Hazard",
    "slip-hazard": "Slip Hazard",
    "water-hazard": "Water Hazard",
    "sinkhole-hazard": "Sinkhole Hazard",
    "heritage-protection": "HERITAGE PROTECTION",
    "protected-building-nat": "Protected Building (Nat.)",
    "protected-building-cant": "Protected Building (Cant.)",
    "protected-objects": "Protected Objects",
    "protected-botanical-objects": "Protected Botanical Objects",
    "archaeological-protection-area": "Archaeological Protection Area",
    "archaeological-site": "Archaeological Site",
    "nature-and-environment": "NATURE AND ENVIRONMENT",
    "proximity-to-water-500-m": "Proximity to Water (500 m)",
    "groundwater-occurrence": "Groundwater Occurrence",
    "forest-areas-and-borders": "Forest Areas and Borders",
    "nature-reserves": "Nature Reserves",
    "water-protection": "Water Protection",
    "public-infrastructure-high-voltage": "Public Infrastructure / High Voltage",
    "public-infrastructure-railway-network": "Public Infrastructure / Railway Network",
    "public-infrastructure-airport": "Public Infrastructure / Airport",
    "notifications": "Notifications",
    "your-browser-does-not-support-push-notifications": "Your browser does not support Push Notifications.",
    "see-browser-support-for": "See browser support for",
    "browser-push-api": "Browser Push API",
    "send-test-notification": "Send Test Notification",
    "account-settings": "Account Settings",
    "profile": "Profile",
    "password-update": "Password Update",
    "please-enter-a-new-password-for-your-account": "Please enter a new password for your account",
    "change-password": "Change Password",
    "save": "Save",
    "user-login-access": "User Login Access",
    "user-access-account": "User Access Account",
    "username": "Username:",
    "roles": "Roles:",
    "for": "for",
    "update-account": "Update Account",
    "reset-locked-account": "Reset Locked Account",
    "delete-login-account": "Delete Login Account",
    "employee": "Employee:",
    "auto-recommended-username": "Auto recommended username",
    "access-rights": "Access Rights",
    "click-to-preset-password-optional": "Click to Preset Password (optional)",
    "go-back": "Go Back",
    "and-send-an-invite-to": "and send an invite to",
    "invitation-contains-instructions-how-user-can-complete-their-login-account-creation": "Invitation contains instructions how user can complete their login account creation.",
    "next": "Next",
    "create-account-and-send-invite": "Create Account and Send Invite",
    "cancel": "Cancel",
    "delete-this-login-account": "Delete this Login Account?",
    "user-will-no-longer-be-able-to-login-to-any-of-hr-systems": "User will no longer be able to login to any of HR systems",
    "delete": "Delete",
    "join": "Join",
    "parcels-with-no-objects": "Parcels with No Objects",
    "no-address": "No address",
    "objects-found": "Objects Found",
    "showing": "Showing"
  },
  de: {
    "language": "Sprache",
    "LANG": "SPRACHE",
    "search": "Suche",
    "filters": "Filter",
    "dashboard": "Dashboard",
    "p-m2": "p/m²",
    "size": "Grundstückfläche",
    "floors": "Stockwerke",
    "zone-1": "Zone 1",
    "zone-2": "Zone 2",
    "full-report": "Vollständiger Bericht",
    "results-are-loading": "Ergebnisse werden geladen...",
    "zoom-in-for-results": "Vergrößern für Ergebnisse",
    "search-for-parcels": "Parzellen suchen",
    "canton": "Kanton",
    "municipality": "Gemeinde",
    "street": "Strasse",
    "parcel-no": "Grundstück-Nr.",
    "parcel-id": "Grundstück-ID",
    "parcel-size-from": "Parzellengröße ab",
    "parcel-size-to": "Parzellengröße bis",
    "thermal": "Thermisch",
    "freeway-from": "Autobahn ab",
    "freeway-to": "Autobahn bis",
    "putra-from": "POI ab",
    "putra-to": "POI bis",
    "alpha-primary": "Nutzung, national",
    "alpha-secondary": "Nutzung, kantonal",
    "loading": "Laden...",
    "basic-data-building": "BASISDATEN-GEBÄUDE",
    "basic-data-parcel": "BASISDATEN-PARZELLE",
    "name": "Name",
    "value": "Wert",
    "coordinates-center": "Koordinatenzentrum",
    "country": "Land",
    "canton-state": "Kanton / Staat",
    "postal-code": "Postleitzahl",
    "number": "Nummer",
    "approx-price-m": "approx. Preis / m²",
    "approx-total-price": "approx. Preis Total",
    "responsible-surveyor": "zuständiger Geometer",
    "detached": "freistehend",
    "built-up": "bebaut",
    "built-up-divisible": "bebaut, teilbar",
    "fixed-point-network-hfp-lfp-1-3": "FIXPUNKTENETZ (HFP+LFP 1-3)",
    "fixed-point-id": "Fixpunkt-ID",
    "fixed-point-number": "Fixpunkt-Nr",
    "fixed-point-name": "Fixpunkt-Name",
    "fixed-point-type": "Fixpunkt-Typ",
    "coordinates": "Fixpunkt-Koordinaten",
    "altitude": "Meereshöhe",
    "distance-to-parcel": "Distanz zu Parzelle",
    "object-id": "Gebäude-ID",
    "footprint-area": "Grundfläche",
    "building-volume": "Gebäudevolumen",
    "centered-coordinates": "Koordinaten-Zentrum",
    "object-type": "Gebäudetyp",
    "number-of-floors": "Vollgeschosse",
    "number-of-units": "Nutzungseinheiten",
    "year-of-construction": "Baujahr",
    "construction-period": "Bauperiode",
    "listed": "Denkmalschutz",
    "basic-zoning-plan": "GBASIS-NUTZUNGSPLAN",
    "alpha-pri": "Nutzung, national",
    "alpha-sec": "Nutzung, kantonal",
    "alpha-ter": "Nutzung, kommunal",
    "special-zoning-plan": "SONDER-NUTZUNGSPLAN",
    "zpp-bravo-pri": "ZPP",
    "ueo-bravo-sec": "UeO",
    "usp-bravo-ter": "USP",
    "overlay-zoning-plan": "NUTZUNGSPLAN-ÜBERLAGERUNGEN",
    "base-building-lines": "Basis-Baulinien",
    "building-lines-cantonal-roads": "Baulinien-Kantonsstrassen",
    "building-lines-national-roads": "Baulinien-Nationalstrassen",
    "building-lines-forest-distance": "Baulinien-Waldabstand",
    "noise-sensitivity-level": "Lärmempfindlichkeitsstufe",
    "water-space-line": "Gewässerraumlinie",
    "water-space": "Gewässerraum",
    "soil-use-and-risks": "BODEN (NUTZUNG UND RISIKEN)",
    "building-ground-assumption": "Baugrund (Annahme)",
    "use-of-geothermal-probes": "Nutzung Erdwärmesonden",
    "use-of-groundwater": "Nutzung Grundwasser",
    "radon-content": "Radongehalt",
    "site-contamination-kbs": "Standortbelastung",
    "infiltration-zones": "Infiltrationszonen",
    "natural-hazards": "NATURGEFAHREN",
    "fall-hazard": "Sturzgefahr",
    "avalanche-hazard": "Lawinengefah",
    "slip-hazard": "Rutschgefahr",
    "water-hazard": "Wassergefahr",
    "sinkhole-hazard": "Dolinengefahr",
    "heritage-protection": "HEIMATSCHUTZ",
    "protected-building-nat": "Geschütztes Gebäude (Nat.)",
    "protected-building-cant": "Geschütztes Gebäude (Kant.)",
    "protected-objects": "geschützte sonstige Objekte",
    "protected-botanical-objects": "geschützte Botanik",
    "archaeological-protection-area": "archäol. Schutzgebiet",
    "archaeological-site": "archäol. Fundstelle",
    "nature-and-environment": "NATUR UND UMWELT",
    "proximity-to-water-500-m": "Gewässernähe (500 m)",
    "groundwater-occurrence": "Grundwasser",
    "forest-areas-and-borders": "Waldnähe (30 m)",
    "nature-reserves": "Naturschutzgebiet",
    "water-protection": "Gewässerschutzbereich",
    "public-infrastructure-high-voltage": "Hochspannung",
    "public-infrastructure-railway-network": "Personenverkehr / Bahn",
    "public-infrastructure-airport": "Flughafen",
    "notifications": "Benachrichtigungen",
    "your-browser-does-not-support-push-notifications": "Ihr Browser unterstützt keine Push-Benachrichtigungen.",
    "see-browser-support-for": "Weitere Informationen zur Browserunterstützung für",
    "browser-push-api": "Browser Push API",
    "send-test-notification": "Testbenachrichtigung senden",
    "account-settings": "Kontoeinstellungen",
    "profile": "Profil",
    "password-update": "Passwortaktualisierung",
    "please-enter-a-new-password-for-your-account": "Bitte geben Sie ein neues Passwort für Ihr Konto ein",
    "change-password": "Passwort ändern",
    "save": "Speichern",
    "user-login-access": "Benutzeranmeldung",
    "user-access-account": "Benutzerzugangskonto",
    "username": "Benutzername:",
    "roles": "Rollen:",
    "for": "für",
    "update-account": "Konto aktualisieren",
    "reset-locked-account": "Gesperrtes Konto zurücksetzen",
    "delete-login-account": "Login-Konto löschen",
    "employee": "Mitarbeiter:",
    "auto-recommended-username": "Automatisch empfohlener Benutzername",
    "access-rights": "Zugriffsrechte",
    "click-to-preset-password-optional": "Zum Voreinstellen des Passworts klicken (optional)",
    "go-back": "Zurückgehen",
    "and-send-an-invite-to": "und eine Einladung senden an",
    "invitation-contains-instructions-how-user-can-complete-their-login-account-creation": "Die Einladung enthält Anweisungen, wie der Benutzer die Erstellung seines Login-Kontos abschließen kann.",
    "next": "Weiter",
    "create-account-and-send-invite": "Konto erstellen und Einladung senden",
    "cancel": "Abbrechen",
    "delete-this-login-account": "Dieses Login-Konto löschen?",
    "user-will-no-longer-be-able-to-login-to-any-of-hr-systems": "Der Benutzer kann sich nicht mehr bei einem der HR-Systeme anmelden",
    "delete": "Löschen",
    "join": "Beitreten",
    "parcels-with-no-objects": "Parzellen ohne Objekte",
    "no-address": "Keine Adresse",
    "objects-found": "Gefundene Objekte",
    "showing": "Anzeigen",

  },
  fr: {
    "language": "Langue",
    "LANG": "LANGUE",
    "search": "Rechercher",
    "filters": "Filtres",
    "dashboard": "Tableau de bord",
    "p-m2": "p/m²",
    "size": "Taille",
    "floors": "étages",
    "zone-1": "Zone 1",
    "zone-2": "Zone 2",
    "full-report": "Rapport complet",
    "results-are-loading": "Les résultats sont en cours de chargement...",
    "zoom-in-for-results": "Zoomer pour voir les résultats",
    "search-for-parcels": "Rechercher des parcelles",
    "canton": "Canton",
    "municipality": "Municipalité",
    "street": "Rue",
    "parcel-no": "N° de parcelle",
    "parcel-id": "ID de parcelle",
    "parcel-size-from": "Taille de parcelle à partir de",
    "parcel-size-to": "Taille de parcelle jusqu'à",
    "thermal": "Thermique",
    "freeway-from": "Autoroute à partir de",
    "freeway-to": "Autoroute jusqu'à",
    "putra-from": "Putra à partir de",
    "putra-to": "Putra jusqu'à",
    "alpha-primary": "Alpha Primaire",
    "alpha-secondary": "Alpha Secondaire",
    "loading": "Chargement...",
    "basic-data-building": "DONNÉES DE BASE - BÂTIMENT",
    "basic-data-parcel": "DONNÉES DE BASE - PARCELLE",
    "name": "Nom",
    "value": "Valeur",
    "coordinates-center": "Centre des coordonnées",
    "country": "Pays",
    "canton-state": "Canton / État",
    "postal-code": "Code postal",
    "number": "Numéro",
    "approx-price-m": "Prix approximatif / m²",
    "approx-total-price": "Prix total approximatif",
    "responsible-surveyor": "Géomètre responsable",
    "detached": "Détaché",
    "built-up": "Construit",
    "built-up-divisible": "Construit, divisible",
    "fixed-point-network-hfp-lfp-1-3": "RÉSEAU DE POINT FIXE (HFP+LFP 1-3)",
    "fixed-point-id": "ID du point fixe",
    "fixed-point-number": "Numéro du point fixe",
    "fixed-point-name": "Nom du point fixe",
    "fixed-point-type": "Type de point fixe",
    "coordinates": "Coordonnées",
    "altitude": "Altitude",
    "distance-to-parcel": "Distance à la parcelle",
    "object-id": "ID de l'objet",
    "footprint-area": "Surface d'empreinte",
    "building-volume": "Volume du bâtiment",
    "centered-coordinates": "Coordonnées centrées",
    "object-type": "Type d'objet",
    "number-of-floors": "Nombre d'étages",
    "number-of-units": "Nombre d'unités",
    "year-of-construction": "Année de construction",
    "construction-period": "Période de construction",
    "listed": "Répertorié",
    "basic-zoning-plan": "PLAN DE ZONAGE DE BASE",
    "alpha-pri": "Alpha PRI",
    "alpha-sec": "Alpha SEC",
    "alpha-ter": "Alpha TER",
    "special-zoning-plan": "PLAN DE ZONAGE SPÉCIAL",
    "zpp-bravo-pri": "ZPP Bravo PRI",
    "ueo-bravo-sec": "UeO : Bravo SEC",
    "usp-bravo-ter": "USP : Bravo TER",
    "overlay-zoning-plan": "PLAN DE ZONAGE SUPERPOSÉ",
    "base-building-lines": "Lignes de base des bâtiments",
    "building-lines-cantonal-roads": "Lignes des routes cantonales",
    "building-lines-national-roads": "Lignes des routes nationales",
    "building-lines-forest-distance": "Distance des lignes de forêt",
    "noise-sensitivity-level": "Niveau de sensibilité au bruit",
    "water-space-line": "Ligne de l'espace aquatique",
    "water-space": "Espace aquatique",
    "soil-use-and-risks": "SOL (UTILISATION ET RISQUES)",
    "building-ground-assumption": "Supposition sur le terrain de construction",
    "use-of-geothermal-probes": "Utilisation de sondes géothermiques",
    "use-of-groundwater": "Utilisation des eaux souterraines",
    "radon-content": "Contenu en radon",
    "site-contamination-kbs": "Contamination du site (KBS)",
    "infiltration-zones": "Zones d'infiltration",
    "natural-hazards": "RISQUES NATURELS",
    "fall-hazard": "Risque de chute",
    "avalanche-hazard": "Risque d'avalanche",
    "slip-hazard": "Risque de glissement",
    "water-hazard": "Risque d'inondation",
    "sinkhole-hazard": "Risque de doline",
    "heritage-protection": "PROTECTION DU PATRIMOINE",
    "protected-building-nat": "Bâtiment protégé (Nat.)",
    "protected-building-cant": "Bâtiment protégé (Cant.)",
    "protected-objects": "Objets protégés",
    "protected-botanical-objects": "Objets botaniques protégés",
    "archaeological-protection-area": "Zone de protection archéologique",
    "archaeological-site": "Site archéologique",
    "nature-and-environment": "NATURE ET ENVIRONNEMENT",
    "proximity-to-water-500-m": "Proximité de l'eau (500 m)",
    "groundwater-occurrence": "Présence d'eau souterraine",
    "forest-areas-and-borders": "Zones et limites forestières",
    "nature-reserves": "Réserves naturelles",
    "water-protection": "Protection de l'eau",
    "public-infrastructure-high-voltage": "Infrastructure publique / Haute tension",
    "public-infrastructure-railway-network": "Infrastructure publique / Réseau ferroviaire",
    "public-infrastructure-airport": "Infrastructure publique / Aéroport",
    "notifications": "Notifications",
    "your-browser-does-not-support-push-notifications": "Votre navigateur ne prend pas en charge les notifications Push.",
    "see-browser-support-for": "Voir la compatibilité des navigateurs pour",
    "browser-push-api": "API de notifications Push du navigateur",
    "send-test-notification": "Envoyer une notification de test",
    "account-settings": "Paramètres du compte",
    "profile": "Profil",
    "password-update": "Mise à jour du mot de passe",
    "please-enter-a-new-password-for-your-account": "Veuillez entrer un nouveau mot de passe pour votre compte",
    "change-password": "Changer le mot de passe",
    "save": "Enregistrer",
    "user-login-access": "Accès utilisateur",
    "user-access-account": "Compte d'accès utilisateur",
    "username": "Nom d'utilisateur :",
    "roles": "Rôles :",
    "for": "pour",
    "update-account": "Mettre à jour le compte",
    "reset-locked-account": "Réinitialiser le compte verrouillé",
    "delete-login-account": "Supprimer le compte de connexion",
    "employee": "Employé :",
    "auto-recommended-username": "Nom d'utilisateur recommandé automatiquement",
    "access-rights": "Droits d'accès",
    "click-to-preset-password-optional": "Cliquer pour définir un mot de passe prédéfini (facultatif)",
    "go-back": "Retourner",
    "and-send-an-invite-to": "et envoyer une invitation à",
    "invitation-contains-instructions-how-user-can-complete-their-login-account-creation": "L'invitation contient des instructions sur la façon dont l'utilisateur peut terminer la création de son compte.",
    "next": "Suivant",
    "create-account-and-send-invite": "Créer un compte et envoyer une invitation",
    "cancel": "Annuler",
    "delete-this-login-account": "Supprimer ce compte de connexion ?",
    "user-will-no-longer-be-able-to-login-to-any-of-hr-systems": "L'utilisateur ne pourra plus se connecter à aucun des systèmes RH",
    "delete": "Supprimer",
    "join": "Rejoindre",
    "parcels-with-no-objects": "Parcelles sans objets",
    "no-address": "Pas d'adresse",
    "objects-found": "Objets trouvés",
    "showing": "Affichage",

  },
  it: {
    "language": "Lingua",
    "LANG": "LINGUA",
    "search": "Cerca",
    "filters": "Filtri",
    "dashboard": "Cruscotto",
    "p-m2": "p/m²",
    "size": "Dimensione",
    "floors": "Piani",
    "zone-1": "Zona 1",
    "zone-2": "Zona 2",
    "full-report": "Rapporto completo",
    "results-are-loading": "I risultati sono in caricamento...",
    "zoom-in-for-results": "Zoom per vedere i risultati",
    "search-for-parcels": "Cerca particelle",
    "canton": "Cantone",
    "municipality": "Municipio",
    "street": "Via",
    "parcel-no": "Numero particella",
    "parcel-id": "ID particella",
    "parcel-size-from": "Dimensione particella da",
    "parcel-size-to": "Dimensione particella a",
    "thermal": "Termico",
    "freeway-from": "Autostrada da",
    "freeway-to": "Autostrada a",
    "putra-from": "Putra da",
    "putra-to": "Putra a",
    "alpha-primary": "Alfa Primario",
    "alpha-secondary": "Alfa Secondario",
    "loading": "Caricamento...",
    "basic-data-building": "DATI DI BASE - EDIFICIO",
    "basic-data-parcel": "DATI DI BASE - PARTICELLA",
    "name": "Nome",
    "value": "Valore",
    "coordinates-center": "Centro coordinate",
    "country": "Paese",
    "canton-state": "Cantone / Stato",
    "postal-code": "Codice Postale",
    "number": "Numero",
    "approx-price-m": "Prezzo appross. / m²",
    "approx-total-price": "Prezzo totale appross.",
    "responsible-surveyor": "Geometra responsabile",
    "detached": "Indipendente",
    "built-up": "Costruito",
    "built-up-divisible": "Costruito, divisibile",
    "fixed-point-network-hfp-lfp-1-3": "RETE DI PUNTI FISSI (HFP+LFP 1-3)",
    "fixed-point-id": "ID Punto Fisso",
    "fixed-point-number": "Numero Punto Fisso",
    "fixed-point-name": "Nome Punto Fisso",
    "fixed-point-type": "Tipo Punto Fisso",
    "coordinates": "Coordinate",
    "altitude": "Altitudine",
    "distance-to-parcel": "Distanza dalla particella",
    "object-id": "ID Oggetto",
    "footprint-area": "Area impronta",
    "building-volume": "Volume edificio",
    "centered-coordinates": "Coordinate centrate",
    "object-type": "Tipo di oggetto",
    "number-of-floors": "Numero di piani",
    "number-of-units": "Numero di unità",
    "year-of-construction": "Anno di costruzione",
    "construction-period": "Periodo di costruzione",
    "listed": "Protetto",
    "basic-zoning-plan": "PIANO REGOLATORE DI BASE",
    "alpha-pri": "Alfa PRI",
    "alpha-sec": "Alfa SEC",
    "alpha-ter": "Alfa TER",
    "special-zoning-plan": "PIANO REGOLATORE SPECIALE",
    "zpp-bravo-pri": "ZPP Bravo PRI",
    "ueo-bravo-sec": "UeO: Bravo SEC",
    "usp-bravo-ter": "USP: Bravo TER",
    "overlay-zoning-plan": "PIANO REGOLATORE SOVRAPPOSTO",
    "base-building-lines": "Linee base edificio",
    "building-lines-cantonal-roads": "Linee edificio strade cantonali",
    "building-lines-national-roads": "Linee edificio strade nazionali",
    "building-lines-forest-distance": "Linee edificio distanza foresta",
    "noise-sensitivity-level": "Livello di sensibilità al rumore",
    "water-space-line": "Linea spazio acquatico",
    "water-space": "Spazio acquatico",
    "soil-use-and-risks": "SUOLO (USO E RISCHI)",
    "building-ground-assumption": "Ipotesi sul terreno edificabile",
    "use-of-geothermal-probes": "Uso di sonde geotermiche",
    "use-of-groundwater": "Uso dell'acqua di falda",
    "radon-content": "Contenuto di Radon",
    "site-contamination-kbs": "Contaminazione sito (KBS)",
    "infiltration-zones": "Zone di infiltrazione",
    "natural-hazards": "RISCHI NATURALI",
    "fall-hazard": "Pericolo di caduta",
    "avalanche-hazard": "Pericolo di valanghe",
    "slip-hazard": "Pericolo di scivolamento",
    "water-hazard": "Pericolo idrico",
    "sinkhole-hazard": "Pericolo di voragini",
    "heritage-protection": "TUTELA DEL PATRIMONIO",
    "protected-building-nat": "Edificio Protetto (Naz.)",
    "protected-building-cant": "Edificio Protetto (Cant.)",
    "protected-objects": "Oggetti protetti",
    "protected-botanical-objects": "Oggetti botanici protetti",
    "archaeological-protection-area": "Zona di protezione archeologica",
    "archaeological-site": "Sito archeologico",
    "nature-and-environment": "NATURA E AMBIENTE",
    "proximity-to-water-500-m": "Vicino all'acqua (500 m)",
    "groundwater-occurrence": "Presenza di acqua di falda",
    "forest-areas-and-borders": "Aree forestali e confini",
    "nature-reserves": "Riserve naturali",
    "water-protection": "Protezione dell'acqua",
    "public-infrastructure-high-voltage": "Infrastruttura Pubblica / Alta Tensione",
    "public-infrastructure-railway-network": "Infrastruttura Pubblica / Rete Ferroviaria",
    "public-infrastructure-airport": "Infrastruttura Pubblica / Aeroporto",
    "notifications": "Notifiche",
    "your-browser-does-not-support-push-notifications": "Il tuo browser non supporta le notifiche Push.",
    "see-browser-support-for": "Vedi il supporto del browser per",
    "browser-push-api": "Browser Push API",
    "send-test-notification": "Invia notifica di prova",
    "account-settings": "Impostazioni account",
    "profile": "Profilo",
    "password-update": "Aggiornamento password",
    "please-enter-a-new-password-for-your-account": "Inserisci una nuova password per il tuo account",
    "change-password": "Cambia password",
    "save": "Salva",
    "user-login-access": "Accesso login utente",
    "user-access-account": "Accesso account utente",
    "username": "Nome utente:",
    "roles": "Ruoli:",
    "for": "per",
    "update-account": "Aggiorna account",
    "reset-locked-account": "Ripristina account bloccato",
    "delete-login-account": "Elimina account di accesso",
    "employee": "Dipendente:",
    "auto-recommended-username": "Nome utente consigliato automaticamente",
    "access-rights": "Diritti di accesso",
    "click-to-preset-password-optional": "Clicca per impostare una password (opzionale)",
    "go-back": "Torna indietro",
    "and-send-an-invite-to": "e invia un invito a",
    "invitation-contains-instructions-how-user-can-complete-their-login-account-creation": "L'invito contiene istruzioni su come completare la creazione dell'account di login.",
    "next": "Successivo",
    "create-account-and-send-invite": "Crea account e invia invito",
    "cancel": "Annulla",
    "delete-this-login-account": "Eliminare questo account di accesso?",
    "user-will-no-longer-be-able-to-login-to-any-of-hr-systems": "L'utente non potrà più accedere a nessuno dei sistemi HR",
    "delete": "Elimina",
    "join": "Unisciti",
    "parcels-with-no-objects": "Particelle senza oggetti",
    "no-address": "Nessun indirizzo",
    "objects-found": "Oggetti trovati",
    "showing": "Visualizzazione",
  }


};

const additionalMessage = {
  en: {
    "quick-search": "quick search",
    "quick-search-for-ch-number-canton-area-street": "quick search for ch number, canton, area, street",
    "results": "Results",
    "layers": "Layers",
    "toggle-layers-on-off-for-visually-rich-experience": "Toggle layers on/off for visually rich experience",
    "toggle-layer-panel": "Toggle Layer Panel",
    "close": "Close",
    "changing-launchage": "Changing Language",
    "show-legend": "Show Legend",
    "hide-legend": "Hide Legend",
    "all": "All",
    "with-objects": "With Objects",
    "without-objects": "Without Objects",
    "object-options": "Object Options",
    "plans": "Plans",
    "upgrade": "Upgrade",
    "check-your-email-for-verification-link": "Check your email for verification link",
    "logout": "Logout",
    "logout-confirmation": "Logout Confirmation",
    "do-you-want-to-logout": "Do you want to logout?",
    "yes": "Yes",
    "building-type": "Building Type",
    "bridge-passerelle": "Bridge / Passerelle",
    "monument": "Monument",
    "building": "Building",
    "building-without-residential-use": "Building without Residential Use",
    "mast-antenna": "Mast / Antenna",
    "wall": "Wall",
    "tunnel-underpass-gallery": "Tunnel / Underpass / Gallery",
    "other-building-part": "Other Building Part",
    "underground-building": "Underground Building",
    "shelter": "Shelter",
    "water-basin": "Water Basin",
    "protected-object": "Protected Object",
    "page": "Page",
    "of": "of",
    "found": "Found",

    "oreb": "OREB",
    "dxf": "DXF",
    "dwg": "DWG",
    "ifg": "IFG",
    "include-roads": "Include Roads",
    "Freehold": "Freehold",
    "Leasehold": "Leasehold",
    "property-type": "Property Type",
    "select-canton": "Select Canton",
    "clear": "Clear",
    
  },
  de: {
    "quick-search": "schnelle Suche",
    "quick-search-for-ch-number-canton-area-street": "schnelle Suche nach ch Nummer, Kanton, Gebiet, Straße",
    "results": "Ergebnisse",
    "layers": "Schichten",
    "toggle-layers-on-off-for-visually-rich-experience": "Schichten ein-/ausschalten für visuell reichhaltige Erfahrung ",
    "toggle-layer-panel": "Schicht-Panel umschalten",
    "close": "Schließen",
    "changing-launchage": "Sprache ändern",
    "show-legend": "Legende anzeigen",
    "hide-legend": "Legende ausblenden",
    "all": "Alle",
    "with-objects": "Mit Objekten",
    "without-objects": "Ohne Objekte",
    "object-options": "Objektoptionen",
    "plans": "Pläne",
    "upgrade": "Upgrade",
    "check-your-email-for-verification-link": "Überprüfen Sie Ihre E-Mail auf den Bestätigungslink",
    "logout": "Ausloggen",
    "logout-confirmation": "Logout Bestätigung",
    "do-you-want-to-logout": "Möchten Sie sich abmelden?",
    "yes": "Ja",
    "building-type": "Gebäudetyp",
    "bridge-passerelle": "Brücke / Passerelle",
    "monument": "Denkmal",
    "building": "Gebäude",
    "building-without-residential-use": "Gebäude ohne Wohnnutzung",
    "mast-antenna": "Mast / Antenne",
    "wall": "Wand",
    "tunnel-underpass-gallery": "Tunnel / Unterführung / Galerie",
    "other-building-part": "Andere Gebäudeteile",
    "underground-building": "Unterirdisches Gebäude",
    "shelter": "Unterstand",
    "water-basin": "Wasserbecken",
    "protected-object": "Geschütztes Objekt",
    "page": "Seite",
    "of": "von",
    "found": "Gefunden",
    "include-roads": "Straßen einbeziehen",
    "Freehold": "Eigentum",
    "Leasehold": "Baurecht",
    "property-type": "Grundstückart",
    "select-canton": "Kanton auswählen",
    "clear": "Löschen",

  },
  fr: {
    "quick-search": "recherche rapide",
    "quick-search-for-ch-number-canton-area-street": "recherche rapide pour ch numéro, canton, région, rue",
    "results": "Résultats",
    "layers": "Couches",
    "toggle-layers-on-off-for-visually-rich-experience": "Activer/désactiver les couches pour une expérience visuelle riche",
    "toggle-layer-panel": "Basculer le panneau de calque",
    "close": "Fermer",
    "changing-launchage": "Changer de langue",
    "show-legend": "Afficher la légende",
    "hide-legend": "Masquer la légende",
    "all": "Tous",
    "with-objects": "Avec objets",
    "without-objects": "Sans objets",
    "object-options": "Options d'objet",
    "plans": "Plans",
    "upgrade": "Mettre à niveau",
    "check-your-email-for-verification-link": "Vérifiez votre e-mail pour le lien de vérification",
    "logout": "Se déconnecter",
    "logout-confirmation": "Confirmation de déconnexion",
    "do-you-want-to-logout": "Voulez-vous vous déconnecter?",
    "yes": "Oui",
    "building-type": "Type de bâtiment",
    "bridge-passerelle": "Pont / Passerelle",
    "monument": "Monument",
    "building": "Bâtiment",
    "building-without-residential-use": "Bâtiment sans usage résidentiel",
    "mast-antenna": "Mât / Antenne",
    "wall": "Mur",
    "tunnel-underpass-gallery": "Tunnel / Passage inférieur / Galerie",
    "other-building-part": "Autre partie du bâtiment",
    "underground-building": "Bâtiment souterrain",
    "shelter": "Abri",
    "water-basin": "Bassin d'eau",
    "protected-object": "Objet protégé",
    "page": "Page",
    "of": "de",
    "found": "Trouvé",
    "include-roads": "Inclure les routes",
    "Freehold": "Propriété",
    "Leasehold": "Bail",
    "property-type": "Type de propriété",
    "select-canton": "Sélectionner le canton",
    "clear": "Effacer",

  },
  it: {
    "quick-search": "ricerca rapida",
    "quick-search-for-ch-number-canton-area-street": "ricerca rapida per ch numero, cantone, area, strada",
    "results": "Risultati",
    "layers": "Strati",
    "toggle-layers-on-off-for-visually-rich-experience": "Attiva/disattiva i livelli per un'esperienza visiva ricca",
    "toggle-layer-panel": "Attiva/disattiva il pannello dei livelli",
    "close": "Chiudi",
    "changing-launchage": "Cambiare lingua",
    "show-legend": "Mostra legenda",
    "hide-legend": "Nascondi legenda",
    "all": "Tutti",
    "with-objects": "Con oggetti",
    "without-objects": "Senza oggetti",
    "object-options": "Opzioni oggetto",
    "plans": "Piani",
    "upgrade": "Aggiornamento",
    "check-your-email-for-verification-link": "Controlla la tua email per il link di verifica",
    "logout": "Disconnettersi",
    "logout-confirmation": "Conferma di disconnessione",
    "do-you-want-to-logout": "Vuoi disconnetterti?",
    "yes": "Sì",
    "building-type": "Tipo di edificio",
    "bridge-passerelle": "Ponte / Passerella",
    "monument": "Monumento",
    "building": "Edificio",
    "building-without-residential-use": "Edificio senza uso residenziale",
    "mast-antenna": "Mast / Antenna",
    "wall": "Muro",
    "tunnel-underpass-gallery": "Tunnel / Sottopasso / Galleria",
    "other-building-part": "Altra parte dell'edificio",
    "underground-building": "Edificio sotterraneo",
    "shelter": "Rifugio",
    "water-basin": "Bacino d'acqua",
    "protected-object": "Oggetto protetto",
    "page": "Pagina",
    "of": "di",
    "found": "Trovato",
    "include-roads": "Includere strade",
    "Freehold": "Proprietà",
    "Leasehold": "Affitto",
    "property-type": "Tipo di proprietà",
    "select-canton": "Seleziona cantone",
    "clear": "Pulisci",
  }
}
const libMessage = {
  en: {
    "terarra-user-agent-login": "Terarra User/Agent Login",
    "username": "Username",
    "password": "Password",
    "enter-your-username": "Enter your username",
    "we-have-emailed-instructions-on-how-to-reset-password-associated-with-this-account": "We have emailed instructions on how to reset password associated with this account",
    "if-you-do-not-receive-email-in-next-few-minutes-please-check-spam-folder-or-contact-us-for-assistance": "If you do not receive email in next few minutes, please check spam folder or contact us for assistance.",
    "login": "Login",
    "authenticating": "Authenticating",
    "processing": "Processing...",
    "reset-password": "Reset Password",
    "go-to-login": "Go to Login",
    "forgot-password": "Forgot Password",
    "back": "Back",
    "new-to-terrara": "New to Terrara",
    "join": "Join",
    "email-verification": "Email Verification",
    "register-with-email": "Register with Email",
    "thank-you": "Thank you",
    "already-have-an-account": "Already have an account",
    "registering": "Registering...",
    "enter-preview-coupon-code": "Enter Preview Coupon Code",
    "valid-email-account": "Valid email account",
    "coupon-code": "Coupon Code *",
    "email": "Email *",
    "please-choose-a-stronger-password-try-a-mix-of-letters-numbers-and-symbols": "Please choose a stronger password. Try a mix of letters, numbers, and symbols.",
    "please-provide-valid-email-address-to-proceed-with-the-registration": "Please provide valid email address to proceed with the registration",
    "email-verification-link-has-been-sent-to-your-email-address-please-check-your-email-and-click-on-the-link-to-verify-your-email-address": "Email verification link has been sent to your email address. Please check your email and click on the link to verify your email address.",
    "error-procesing-your-request-please-check-your-internet-connection-and-try-again": "Error processing your request. Please check your internet connection and try again",
    "please-fill-in-all-fields": "Please fill in all fields",
    "password-and-confirm-password-do-not-match": "Password and Confirm Password do not match",
    "verify-email": "VERIFY EMAIL",
    "invalid-coupon-code": "Invalid coupon code",
    "activation-verification-in-progress": "Activation verification in progress. Please wait",
    "email-verification-successful": "Email verification successful",
    "register-terarra-user-agent": "Register Terarra User/Agent",
    "company-agent-details": "Company/Agent Details",
    "company-name": "Company Name",
    "full-name": "Full Name",
    "phone-number": "Phone Number",
    "company-address": "Company Address",
    "user-login-details": "User Login Details",
    "set-password": "Set password",
    "password-hint": "Try a mix of letters, numbers, and symbols. Min 8 characters",
    "confirm-password": "Confirm Password",
    "registration-successful-pending-activation": "Registration Successful / Pending Activation",
    "registration-successful-message": "Your registration is successful. We have emailed instructions on how to activate this account.",
    "check-spam-folder-message": "If you do not receive email in next few minutes, please check spam folder or contact us for assistance.",
    "register": "REGISTER",
    "enter-a-password": "Enter a password",
    "use-8-characters-or-more-for-your-password": "Use 8 characters or more for your password",
    "please-choose-a-stronger-password": "Please choose a stronger password. Try a mix of letters, numbers, and symbols.",
    "invalid-activation-key": "Invalid activation key. Activation key may have expired or already used",
    "error-processing-your-request": "Error processing your request. Please check your internet connection and try again",
    "advance-search-tuning": "Advance Search Tuning",
    "we-will-send-email-to-address-associated-with-this-username": "We will send email to address associated with this username"
  },
  de: {
    "terarra-user-agent-login": "Terarra Benutzer/Agent Login",
    "username": "Benutzername",
    "password": "Passwort",
    "enter-your-username": "Geben Sie Ihren Benutzernamen ein",
    "we-have-emailed-instructions-on-how-to-reset-password-associated-with-this-account": "Wir haben Anweisungen per E-Mail gesendet, wie Sie das Passwort zu diesem Konto zurücksetzen können",
    "if-you-do-not-receive-email-in-next-few-minutes-please-check-spam-folder-or-contact-us-for-assistance": "Wenn Sie in den nächsten Minuten keine E-Mail erhalten, überprüfen Sie bitte den Spam-Ordner oder kontaktieren Sie uns für Unterstützung.",
    "login": "Anmeldung",
    "authenticating": "Authentifizierung",
    "processing": "Verarbeitung...",
    "reset-password": "Passwort zurücksetzen",
    "go-to-login": "Zum Login gehen",
    "forgot-password": "Passwort vergessen",
    "back": "Zurück",
    "new-to-terrara": "Neu bei Terrara",
    "join": "Beitreten",
    "email-verification": "E-Mail-Verifikation",
    "register-with-email": "Mit E-Mail registrieren",
    "thank-you": "Danke",
    "already-have-an-account": "Haben Sie bereits ein Konto?",
    "registering": "Registrierung...",
    "enter-preview-coupon-code": "Geben Sie den Vorschau-Coupon-Code ein",
    "valid-email-account": "Gültiges E-Mail-Konto",
    "coupon-code": "Gutscheincode *",
    "email": "E-Mail *",
    "please-choose-a-stronger-password-try-a-mix-of-letters-numbers-and-symbols": "Bitte wählen Sie ein stärkeres Passwort. Versuchen Sie eine Mischung aus Buchstaben, Zahlen und Symbolen.",
    "please-provide-valid-email-address-to-proceed-with-the-registration": "Bitte geben Sie eine gültige E-Mail-Adresse ein, um mit der Registrierung fortzufahren.",
    "email-verification-link-has-been-sent-to-your-email-address-please-check-your-email-and-click-on-the-link-to-verify-your-email-address": "Ein Verifizierungslink wurde an Ihre E-Mail-Adresse gesendet. Bitte prüfen Sie Ihre E-Mails und klicken Sie auf den Link, um Ihre E-Mail-Adresse zu verifizieren.",
    "error-procesing-your-request-please-check-your-internet-connection-and-try-again": "Fehler bei der Bearbeitung Ihrer Anfrage. Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.",
    "please-fill-in-all-fields": "Bitte füllen Sie alle Felder aus.",
    "password-and-confirm-password-do-not-match": "Passwort und Bestätigungspasswort stimmen nicht überein.",
    "verify-email": "E-MAIL VERIFIZIEREN",
    "invalid-coupon-code": "Ungültiger Gutscheincode",
    "activation-verification-in-progress": "Aktivierungsüberprüfung läuft. Bitte warten",
    "email-verification-successful": "E-Mail-Verifizierung erfolgreich",
    "register-terarra-user-agent": "Terarra Benutzer/Agent registrieren",
    "company-agent-details": "Unternehmens-/Agentendetails",
    "company-name": "Firmenname",
    "full-name": "Vollständiger Name",
    "phone-number": "Telefonnummer",
    "company-address": "Firmenadresse",
    "user-login-details": "Benutzeranmeldedaten",
    "set-password": "Passwort festlegen",
    "password-hint": "Versuchen Sie eine Mischung aus Buchstaben, Zahlen und Symbolen. Mindestens 8 Zeichen",
    "confirm-password": "Passwort bestätigen",
    "registration-successful-pending-activation": "Registrierung erfolgreich / Aktivierung ausstehend",
    "registration-successful-message": "Ihre Registrierung war erfolgreich. Wir haben Anweisungen per E-Mail gesendet, wie Sie dieses Konto aktivieren können.",
    "check-spam-folder-message": "Wenn Sie in den nächsten Minuten keine E-Mail erhalten, überprüfen Sie bitte den Spam-Ordner oder kontaktieren Sie uns für Unterstützung.",
    "register": "REGISTRIEREN",
    "enter-a-password": "Geben Sie ein Passwort ein",
    "use-8-characters-or-more-for-your-password": "Verwenden Sie 8 Zeichen oder mehr für Ihr Passwort",
    "please-choose-a-stronger-password": "Bitte wählen Sie ein stärkeres Passwort. Versuchen Sie eine Mischung aus Buchstaben, Zahlen und Symbolen.",
    "invalid-activation-key": "Ungültiger Aktivierungsschlüssel. Der Aktivierungsschlüssel ist möglicherweise abgelaufen oder wurde bereits verwendet",
    "error-processing-your-request": "Fehler bei der Bearbeitung Ihrer Anfrage. Bitte überprüfen Sie Ihre Internetverbindung und versuchen Sie es erneut",
    "advance-search-tuning": "Erweiterte Sucheinstellungen",
    "we-will-send-email-to-address-associated-with-this-username": "Wir werden eine E-Mail an die mit diesem Benutzernamen verknüpfte Adresse senden"

  },
  fr: {
    "terarra-user-agent-login": "Terarra Utilisateur/Agent Connexion",
    "username": "Nom d'utilisateur",
    "password": "Mot de passe",
    "enter-your-username": "Entrez votre nom d'utilisateur",
    "we-have-emailed-instructions-on-how-to-reset-password-associated-with-this-account": "Nous avons envoyé des instructions par e-mail sur la façon de réinitialiser le mot de passe associé à ce compte",
    "if-you-do-not-receive-email-in-next-few-minutes-please-check-spam-folder-or-contact-us-for-assistance": "Si vous ne recevez pas d'e-mail dans les prochaines minutes, veuillez vérifier le dossier de spam ou nous contacter pour obtenir de l'aide.",
    "login": "Connexion",
    "authenticating": "Authentification",
    "processing": "Traitement...",
    "reset-password": "Réinitialiser le mot de passe",
    "go-to-login": "Aller à la connexion",
    "forgot-password": "Mot de passe oublié",
    "back": "Retour",
    "new-to-terrara": "Nouveau sur Terrara",
    "join": "Rejoindre",
    "email-verification": "Vérification de l'E-mail",
    "register-with-email": "S'inscrire avec un E-mail",
    "thank-you": "Merci",
    "already-have-an-account": "Vous avez déjà un compte ?",
    "registering": "Enregistrement...",
    "enter-preview-coupon-code": "Entrez le code du coupon de prévisualisation",
    "valid-email-account": "Compte E-mail valide",
    "coupon-code": "Code du coupon *",
    "email": "E-mail *",
    "please-choose-a-stronger-password-try-a-mix-of-letters-numbers-and-symbols": "Veuillez choisir un mot de passe plus sécurisé. Essayez une combinaison de lettres, chiffres et symboles.",
    "please-provide-valid-email-address-to-proceed-with-the-registration": "Veuillez fournir une adresse E-mail valide pour continuer l'enregistrement.",
    "email-verification-link-has-been-sent-to-your-email-address-please-check-your-email-and-click-on-the-link-to-verify-your-email-address": "Un lien de vérification a été envoyé à votre adresse E-mail. Veuillez vérifier vos E-mails et cliquer sur le lien pour vérifier votre adresse E-mail.",
    "error-procesing-your-request-please-check-your-internet-connection-and-try-again": "Erreur lors du traitement de votre demande. Veuillez vérifier votre connexion Internet et réessayer.",
    "please-fill-in-all-fields": "Veuillez remplir tous les champs.",
    "password-and-confirm-password-do-not-match": "Le mot de passe et la confirmation du mot de passe ne correspondent pas.",
    "verify-email": "VÉRIFIER L'EMAIL",
    "invalid-coupon-code": "Code de coupon invalide",
    "activation-verification-in-progress": "Vérification de l'activation en cours. Veuillez patienter",
    "email-verification-successful": "Vérification de l'email réussie",
    "register-terarra-user-agent": "Enregistrer l'utilisateur/agent Terarra",
    "company-agent-details": "Détails de l'entreprise/agent",
    "company-name": "Nom de l'entreprise",
    "full-name": "Nom complet",
    "phone-number": "Numéro de téléphone",
    "company-address": "Adresse de l'entreprise",
    "user-login-details": "Détails de connexion de l'utilisateur",
    "set-password": "Définir le mot de passe",
    "password-hint": "Essayez un mélange de lettres, de chiffres et de symboles. Min 8 caractères",
    "confirm-password": "Confirmer le mot de passe",
    "registration-successful-pending-activation": "Inscription réussie / Activation en attente",
    "registration-successful-message": "Votre inscription a réussi. Nous avons envoyé des instructions par e-mail sur la façon d'activer ce compte.",
    "check-spam-folder-message": "Si vous ne recevez pas d'e-mail dans les prochaines minutes, veuillez vérifier le dossier de spam ou nous contacter pour obtenir de l'aide.",
    "register": "ENREGISTRER",
    "enter-a-password": "Entrez un mot de passe",
    "use-8-characters-or-more-for-your-password": "Utilisez 8 caractères ou plus pour votre mot de passe",
    "please-choose-a-stronger-password": "Veuillez choisir un mot de passe plus sécurisé. Essayez une combinaison de lettres, chiffres et symboles.",
    "invalid-activation-key": "Clé d'activation invalide. La clé d'activation peut avoir expiré ou avoir déjà été utilisée",
    "error-processing-your-request": "Erreur lors du traitement de votre demande. Veuillez vérifier votre connexion Internet et réessayer",
    "advance-search-tuning": "Réglage de la recherche avancée",

    "we-will-send-email-to-address-associated-with-this-username": "Nous enverrons un e-mail à l'adresse associée à ce nom d'utilisateur"

  },
  it: {
    "terarra-user-agent-login": "Terarra Utente/Agente Login",
    "username": "Nome utente",
    "password": "Parola d'ordine",
    "enter-your-username": "Inserisci il tuo nome utente",
    "we-have-emailed-instructions-on-how-to-reset-password-associated-with-this-account": "Abbiamo inviato istruzioni via e-mail su come reimpostare la password associata a questo account",
    "if-you-do-not-receive-email-in-next-few-minutes-please-check-spam-folder-or-contact-us-for-assistance": "Se non ricevi l'e-mail nei prossimi minuti, controlla la cartella dello spam o contattaci per assistenza.",
    "login": "Accesso",
    "authenticating": "Autenticazione",
    "processing": "Elaborazione...",
    "reset-password": "Reimposta la password",
    "go-to-login": "Vai al login",
    "forgot-password": "Password dimenticata",
    "back": "Indietro",
    "new-to-terrara": "Nuovo su Terrara",
    "join": "Unisciti",
    "email-verification": "Verifica E-mail",
    "register-with-email": "Registrati con E-mail",
    "thank-you": "Grazie",
    "already-have-an-account": "Hai già un account?",
    "registering": "Registrazione in corso...",
    "enter-preview-coupon-code": "Inserisci il codice coupon di anteprima",
    "valid-email-account": "Account E-mail valido",
    "coupon-code": "Codice Coupon *",
    "email": "E-mail *",
    "please-choose-a-stronger-password-try-a-mix-of-letters-numbers-and-symbols": "Scegli una password più sicura. Prova una combinazione di lettere, numeri e simboli.",
    "please-provide-valid-email-address-to-proceed-with-the-registration": "Fornisci un indirizzo E-mail valido per procedere con la registrazione.",
    "email-verification-link-has-been-sent-to-your-email-address-please-check-your-email-and-click-on-the-link-to-verify-your-email-address": "Il link di verifica è stato inviato al tuo indirizzo E-mail. Controlla la tua E-mail e fai clic sul link per verificare il tuo indirizzo E-mail.",
    "error-procesing-your-request-please-check-your-internet-connection-and-try-again": "Errore durante l'elaborazione della tua richiesta. Verifica la tua connessione Internet e riprova.",
    "please-fill-in-all-fields": "Compila tutti i campi.",
    "password-and-confirm-password-do-not-match": "La password e la conferma della password non corrispondono.",
    "verify-email": "VERIFICA EMAIL",
    "invalid-coupon-code": "Codice coupon non valido",
    "activation-verification-in-progress": "Verifica dell'attivazione in corso. Attendere prego",
    "email-verification-successful": "Verifica dell'email riuscita",
    "register-terarra-user-agent": "Registra utente/agente Terarra",
    "company-agent-details": "Dettagli azienda/agente",
    "company-name": "Nome dell'azienda",
    "full-name": "Nome completo",
    "phone-number": "Numero di telefono",
    "company-address": "Indirizzo dell'azienda",
    "user-login-details": "Dettagli di accesso dell'utente",
    "set-password": "Imposta password",
    "password-hint": "Prova una combinazione di lettere, numeri e simboli. Min 8 caratteri",
    "confirm-password": "Conferma password",
    "registration-successful-pending-activation": "Registrazione riuscita / Attivazione in sospeso",
    "registration-successful-message": "La tua registrazione è avvenuta con successo. Abbiamo inviato istruzioni via e-mail su come attivare questo account.",
    "check-spam-folder-message": "Se non ricevi l'e-mail nei prossimi minuti, controlla la cartella dello spam o contattaci per assistenza.",
    "register": "REGISTRA",
    "enter-a-password": "Inserisci una password",
    "use-8-characters-or-more-for-your-password": "Usa 8 caratteri o più per la tua password",
    "please-choose-a-stronger-password": "Scegli una password più sicura. Prova una combinazione di lettere, numeri e simboli.",
    "invalid-activation-key": "Chiave di attivazione non valida. La chiave di attivazione potrebbe essere scaduta o già utilizzata",
    "error-processing-your-request": "Errore durante l'elaborazione della tua richiesta. Verifica la tua connessione Internet e riprova",
    "advance-search-tuning": "Regolazione della ricerca avanzata",
    "we-will-send-email-to-address-associated-with-this-username": "Invieremo un'e-mail all'indirizzo associato a questo nome utente"

  }
}

Object.keys(additionalMessage).forEach(lang => {
  messages[lang] = Object.assign(messages[lang], additionalMessage[lang]);
});
Object.keys(libMessage).forEach(lang => {
  messages[lang] = Object.assign(messages[lang], libMessage[lang]);
});

const savedLanguage = localStorage.getItem("user-language")
const i18n = new VueI18n({
  locale: savedLanguage||'en', // Set the default locale
  messages,
});

export default i18n;